/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exchangeMetaTokenCustomer } from '../fn/meta-subscription-api/exchange-meta-token-customer';
import { ExchangeMetaTokenCustomer$Params } from '../fn/meta-subscription-api/exchange-meta-token-customer';
import { registerCustomerPhoneNumber } from '../fn/meta-subscription-api/register-customer-phone-number';
import { RegisterCustomerPhoneNumber$Params } from '../fn/meta-subscription-api/register-customer-phone-number';
import { subscribeToWebhookCustomer } from '../fn/meta-subscription-api/subscribe-to-webhook-customer';
import { SubscribeToWebhookCustomer$Params } from '../fn/meta-subscription-api/subscribe-to-webhook-customer';

@Injectable({ providedIn: 'root' })
export class MetaSubscriptionApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `subscribeToWebhookCustomer()` */
  static readonly SubscribeToWebhookCustomerPath = '/v1/api/ui/meta-subscription/subscribe-customer/{wabaId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribeToWebhookCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeToWebhookCustomer$Response(params: SubscribeToWebhookCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribeToWebhookCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribeToWebhookCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribeToWebhookCustomer(params: SubscribeToWebhookCustomer$Params, context?: HttpContext): Observable<void> {
    return this.subscribeToWebhookCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `registerCustomerPhoneNumber()` */
  static readonly RegisterCustomerPhoneNumberPath = '/v1/api/ui/meta-subscription/register-customer/{wabaPhoneIdentifier}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerCustomerPhoneNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  registerCustomerPhoneNumber$Response(params: RegisterCustomerPhoneNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return registerCustomerPhoneNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerCustomerPhoneNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  registerCustomerPhoneNumber(params: RegisterCustomerPhoneNumber$Params, context?: HttpContext): Observable<void> {
    return this.registerCustomerPhoneNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exchangeMetaTokenCustomer()` */
  static readonly ExchangeMetaTokenCustomerPath = '/v1/api/ui/meta-subscription/exchange-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exchangeMetaTokenCustomer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exchangeMetaTokenCustomer$Response(params: ExchangeMetaTokenCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return exchangeMetaTokenCustomer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exchangeMetaTokenCustomer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exchangeMetaTokenCustomer(params: ExchangeMetaTokenCustomer$Params, context?: HttpContext): Observable<void> {
    return this.exchangeMetaTokenCustomer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
